<template>
  <v-layout column fill-height>
    <breadcrumbs
      v-on:selectTab="changeTab"
      :guia="guia"
      titulo="2ª Via Digital"
      descricao="Gere 2ª via de apólices, certificados, endossos, faturas e boletos."
      :tabs="tabOptions"
    />

    <v-layout class="main">
      <apolices v-if="tab == 1" />
      <certificados v-if="tab == 2" />
      <endossos v-if="tab == 3" />
      <faturas v-if="tab == 4" />
      <boletos v-if="tab == 5" />
    </v-layout>
  </v-layout>
</template>

<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import apolices from "@/components/portal/emissoes/Apolices";
import certificados from "@/components/portal/emissoes/Certificados";
import endossos from "@/components/portal/emissoes/Endossos";
import faturas from "@/components/portal/emissoes/Faturas";
import boletos from "@/components/portal/emissoes/Boletos";

export default {
  components: {
    breadcrumbs,
    apolices,
    certificados,
    endossos,
    faturas,
    boletos,
  },
  data() {
    return {
      tab: 1,
      guia: "Emissões > Apólice",
      tabOptions: [
        { id: 1, titulo: "Apólices" },
        { id: 2, titulo: "Certificados" },
        { id: 3, titulo: "Endossos" },
        { id: 4, titulo: "Faturas" },
        { id: 5, titulo: "Boletos" },
      ],
    };
  },
  methods: {
    changeTab(value) {
      this.tab = value;
      this.guia = "Emissoes > " + this.tabOptions[value - 1].titulo;
    },
  },
};
</script>
